import { GymTypes } from 'fitbeat.models';
import { AreaCategory } from '../../config/zone-mappings';
import { WorkoutSettings } from '../../entities/user/workoutsettings';
import { WorkoutSelection } from '../../entities/workout/workoutselection';
import { UserWorkoutSession } from '../../entities/workoutsession/userworkoutsession';
import { CurrentWorkoutSelectionManager, WorkoutSelectionManager } from '../workoutselection';
import { IWorkoutSelectionStrategy } from './IWorkoutSelectionStrategy';

export class CurrentDayWorkoutSelectionStrategy implements IWorkoutSelectionStrategy {
  private activeWorkoutSelectionCache = {};

  constructor(
    private currentWorkoutSelectionManager: CurrentWorkoutSelectionManager,
    private workoutSelectionManager: WorkoutSelectionManager,
  ) { }

  public async getWorkoutSelectionForWorkout(
    settings: WorkoutSettings,
    gymType: GymTypes,
    requestTime: Date,
    timezone: string,
    userWorkoutSession?: UserWorkoutSession,
  ): Promise<WorkoutSelection | undefined> {
    const areaCategory = userWorkoutSession?.areaCategory ?? 'circuit';
    const keyReference = CurrentWorkoutSelectionManager.activeSelectionId(gymType, settings);
    const activeWorkoutSelection = await this.getActiveWorkoutSelection(
      keyReference,
      settings,
      gymType,
      areaCategory,
      timezone,
    );
    return activeWorkoutSelection;
  }

  private async getActiveWorkoutSelection(
    keyReference: string,
    settings: WorkoutSettings,
    gymType: GymTypes,
    area: AreaCategory | undefined,
    timezone: string,
  )
    : Promise<WorkoutSelection | undefined> {
    // Not sure how this ever worked. There must be a place where the cache is invalidated
    let activeWorkoutSelection = this.activeWorkoutSelectionCache[keyReference];
    if (!activeWorkoutSelection) {
      const workoutSelection = await this.currentWorkoutSelectionManager.getCurrentWorkoutSelection(
        gymType,
        settings,
        timezone,
        area,
      );
      if (workoutSelection) {
        this.activeWorkoutSelectionCache[keyReference] = workoutSelection;
        activeWorkoutSelection = workoutSelection;
      } else {
        const defaultWorkoutSelection = await this.workoutSelectionManager
          .getDefaultWorkoutSelection(settings, gymType, area);
        this.activeWorkoutSelectionCache[keyReference] = defaultWorkoutSelection;
        return defaultWorkoutSelection;
      }
    }
    await this.workoutSelectionManager.populateExercises(activeWorkoutSelection.exerciseSelections);
    return activeWorkoutSelection;
  }
}
